<script>
  import Avatar from "./Elemental Components/Avatar.svelte";
  import { navStatus } from "./AppState/Stores";

  let CodyAvatar = 'images/CodyAvatar.jpg';
  let RocketAvatar = 'images/Rocket.jpg';
  let SamAvatar = 'images/Sam.jpg';
  let Charlotte = 'images/CharlotteOne.jpg';
  let Charlotte2 = 'images/TwoPointOh.jpg';
  let Dagron = 'images/Dagron.jpg';

</script>

<main>
  <sectionHeader><p><i>timelines</i></p></sectionHeader>
  <row class:active="{$navStatus === 'featured'}"
    on:click="{ () => { $navStatus = 'featured'; }}">
    <img src="images/icons/cat.png"/>
    <h2>featured</h2>
  </row>
  <row class:active="{$navStatus === 'following'}"
       on:click="{ () => { $navStatus = 'following'; }}">
    <img src="images/icons/rabbit.png"/>
    <h2>following</h2>
  </row>
  <row class:active="{$navStatus === 'favorites'}"
    on:click="{ () => { $navStatus = 'favorites'; }}">
    <img src="images/icons/turtle.png"/>
    <h2>favorites</h2>
  </row>
  <dividerLine/>

  <sectionHeader><p><i>my stories</i></p></sectionHeader>
  <row class:active="{$navStatus === 'shared'}"
       on:click="{ () => { $navStatus = 'shared'; }}">
    <img src="images/icons/dog-footprint.png"/>
    <h2>shared</h2>
  </row>
  <row class:active="{$navStatus === 'private'}"
    on:click="{ () => { $navStatus = 'private'; }}">
    <img src="images/icons/cat.png"/>
    <h2>private</h2>
  </row>
  <dividerLine/>

  <sectionHeader><p><i>my pets</i></p></sectionHeader>
  <avatars>
    <Avatar imageLocation={CodyAvatar} />
    <Avatar imageLocation={RocketAvatar} />
    <Avatar imageLocation={SamAvatar} />
    <Avatar imageLocation={Charlotte} />
    <Avatar imageLocation={Dagron} />
    <Avatar imageLocation={Charlotte2} />
    <Avatar imageLocation={SamAvatar} />
  </avatars>
  <dividerLine/>

<!--  <sectionHeader><p><i>create</i></p></sectionHeader>-->
<!--  <row class:active="{$navStatus === 'media'}"-->
<!--    on:click="{ () => { $navStatus = 'media'; }}">-->
<!--    <img src="images/icons/cat.png"/>-->
<!--    <h2>media</h2>-->
<!--  </row>-->
<!--  <row class:active="{$navStatus === 'memories'}"-->
<!--    on:click="{ () => { $navStatus = 'memories'; }}">-->
<!--    <img src="images/icons/dog-footprint.png"/>-->
<!--    <h2>memories</h2>-->
<!--  </row>-->
<!--  <row class:active="{$navStatus === 'collection'}"-->
<!--       on:click="{ () => { $navStatus = 'collection'; }}">-->
<!--    <img src="images/icons/dog-footprint.png"/>-->
<!--    <h2>collections</h2>-->
<!--  </row>-->
<!--  <dividerLine/>-->

</main>



<style>
  main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  avatars {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  sectionHeader {
    margin-left: 18px;
  }

  row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    vertical-align: center;
    height: 44px;
    padding: 7px 20px 7px 10px;
    margin-right: auto;
    margin-bottom: 4px;
  }

  .active img {
    opacity: 1;
  }
  .active h2 {
    opacity: 1;
    font-weight: 400;
  }

  img {
    width: 50px;
    height: 50px;
    margin-top: auto;
    margin-bottom: auto;
  }

  h2 {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-left: 8px;
    font-size: 2rem;
    vertical-align: center;
    opacity: 0.7;
  }

  row img {
    opacity: 0;
  }

  row:hover {
    border-radius: 7px;
    background-color: rgba(225,235,255,0.7);
  }
  row:hover h2 {
    font-style: italic;
  }

  cat { background-image: url('../images/icons/cat.png'); }
  turtle a { background-image: url('../images/icons/turtle.png'); }
  rabbit a { background-image: url('../images/icons/rabbit.png'); }
  dogPaw a { background-image: url('../images/icons/dog-footprint.png'); }

  dividerLine {
    background-color: rgba(107,118,141,0.3);
    width: 80%;
    height: 1px;
    margin-top: 8px;
    margin-bottom: 15px;
  }
</style>